interface SchemaOrgProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'BreadcrumbList' | 'Article' | 'FAQPage';
  data?: Record<string, unknown>;
}

export default function SchemaOrg({ type, data }: SchemaOrgProps) {
  let schema: Record<string, unknown>;

  switch (type) {
    case 'Organization':
      schema = {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: '91爆料网',
        url: 'http://gm3pta.cn/',
        description: '91爆料网为你提供第一手社会热点与劲爆八卦，是真正的吃瓜导航平台。每日实时曝料网红黑料、娱乐八卦、社会热点。',
        logo: 'http://gm3pta.cn/logo.png',
        contactPoint: {
          '@type': 'ContactPoint',
          telephone: '400-888-9191',
          contactType: 'customer service',
          email: 'hello@gm3pta.cn',
        },
      };
      break;
    case 'WebSite':
      schema = {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: '91爆料网',
        url: 'http://gm3pta.cn/',
        description: '全新91网站免费吃瓜入口，深扒网红黑料与热门大瓜，每日全网实时曝。',
        potentialAction: {
          '@type': 'SearchAction',
          target: 'http://gm3pta.cn/search?q={search_term_string}',
          'query-input': 'required name=search_term_string',
        },
      };
      break;
    case 'WebPage':
      schema = {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        ...data,
      };
      break;
    case 'BreadcrumbList':
      schema = {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        ...data,
      };
      break;
    case 'Article':
      schema = {
        '@context': 'https://schema.org',
        '@type': 'Article',
        ...data,
      };
      break;
    case 'FAQPage':
      schema = {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        ...data,
      };
      break;
    default:
      schema = { '@context': 'https://schema.org', '@type': 'Thing', ...data };
  }

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}
